import './template-request-quote.scss';
import {initGformButtons} from '../../../../assets/src/ts/utils/gform-buttons';
import {handleFileUpload} from '../../../../assets/src/ts/utils/file-upload';
import {configuratorRedirect} from "../../../../assets/src/ts/modules/RequestQuoteForm/features/configuratorRedirect";

const initRequestQuoteForm = () => {
    const requestQuotePage = document.querySelector('.template-request-quote') as HTMLElement
    if (!requestQuotePage) return;

    // Redirection configurateur (étape 2 / Base vie roulante).
    configuratorRedirect();

    // Progress Bar.
    const steps = document.querySelectorAll('.gf_page_steps .gf_step') as NodeListOf<HTMLLIElement>
    const total = steps.length;
    let currentStep = 0;

    steps.forEach((step, index) => {
        if (step.classList.contains('gf_step_active')) {
            currentStep = index + 1;
        }
    });

    const percent = Math.round((currentStep / total) * 100);

    const progressWrapper = document.createElement('div');
    progressWrapper.className = 'progress-bar-wrapper';

    const progressBar = document.createElement('div');
    progressBar.className = 'progress-bar';
    progressBar.style.width = `${percent}%`;

    progressWrapper.appendChild(progressBar);

    const pages = document.querySelectorAll('.gform_page ');
    let visiblePage: HTMLElement | null = null;
    pages.forEach(footer => {
        const style = window.getComputedStyle(footer);
        if (style.display !== 'none') {
            visiblePage = footer.querySelector('.gform-page-footer') as HTMLElement
        }
    });

    if (visiblePage !== null) {
        (visiblePage as HTMLElement).prepend(progressWrapper);
    }


    // Move required field text.
    const requiredLegend = document.querySelector('.gform_required_legend');
    const form = requestQuotePage.querySelector('.gform_wrapper form') as HTMLElement
    if (requiredLegend && form) {
        form.appendChild(requiredLegend);
    }

}

initRequestQuoteForm();
initGformButtons();
handleFileUpload();
